import axios from "axios";

// Constants
import constants from "@/constants";

// Utils
import { handleCommonRequest, handleCommonResponse } from "./common-response";

let instance = axios.create({
	baseURL: constants.offlineFairsApi + "/v1",
});

handleCommonRequest(instance);
handleCommonResponse(instance);

export default instance;
